import React from 'react'
import { enableHomePageSSR, enableNewFeature, i18nTranslate } from 'src/utils'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import {
  accountsContainer,
  customerContainer,
  studioContainer,
  storeContainer,
  mysiteContainer,
  personalOfferContainer,
} from 'src/models'
import {
  ApiContent,
  getLocalStorage,
  getLocaleCodeFromUrl,
  getLiveEventStatus,
  fetchResponseFromAPI,
} from 'src/utils'
import { consentIpAddress, getSessionStorage } from 'config/appConfig'
import { EmailVerification, MetaDecorator } from 'src/views/components'
import LeaderPreviewModal from 'src/views/studioComponents/LeaderPreviewModal'
import { fontDetails, getCustomStyleForLocale } from './getDynamicLocaleFont'
import { EventStudioPage } from 'src/views/pages/EventStudioPage'
import {
  trackInsiderPageView,
  trackInsiderCartEvents,
  trackInsiderSignupEvent,
} from 'src/utils/insider'
import { getCookie, deleteCookie } from 'config/appConfig'
import './styles.scss'
import MicroFrontendLoader from 'src/views/components/MicroFrontends/MicroFrontendLoader'
import {
  getMySiteUrlStatus,
  isEquinoxMysite,
  isEquinoxPOSite,
} from 'src/utils/mySiteUtils'
import { PersonalOffer } from '../PersonalOffer'
import MysiteNotFound from '../NotFound/MysiteNotFound'
import { SPONSOR } from 'src/utils/constant'
import ContentStack from 'src/api/contentStack'
import ProductStatusBadge from 'src/views/components/CatalogViews/ProductCard/ProductStatusBadge'
@observer
class StudioPage extends React.Component {
  nameSpace = 'ssr-resource'
  static contextType = ApiContent
  @observable studioData = []
  constructor(props, context) {
    super(props)
    this.context = context
    this.contextName = 'studioData'
    this.currentLocale = getLocaleCodeFromUrl({
      defaultLocale: 'en_US',
      isReverseType: true,
    })
    this.getDataFromSource()
  }
  getDataFromSource = async () => {
    const studioData = this.context?.ssrData?.studioData || {}
    if (Object.keys(studioData).length > 0) {
      // studioContainer.studioData = this.studioData
      this.studioData = studioData
    } else {
      await this.getStudioData()
    }
  }
  getStudioData = async () => {
    this.studioData = await studioContainer.getStudioResponse({
      context: this.context,
      contextName: this.contextName,
    })
    studioContainer.studioData = this.studioData
  }
  componentDidMount() {
    const isNewHeaderEnabled = enableNewFeature('enableNewHeaderNavigation')
    const bodyElement = document.querySelector('body')
    bodyElement.classList.toggle(
      'enable-new-header-navigation',
      isNewHeaderEnabled
    )

    if (isEquinoxMysite()) {
      getMySiteUrlStatus({ sync: true })
    }

    const trackSignupEvent = getCookie('trackInsiderSignup')

    if (trackSignupEvent) {
      trackInsiderSignupEvent()
      deleteCookie('trackInsiderSignup')
    }

    trackInsiderPageView({ pageType: 'home' })
    if (
      enableNewFeature('enableHomePageSeo') &&
      !studioContainer.nextgenHomepageData
    ) {
      studioContainer.fetchNextgenHomepageData(this.currentLocale || 'en_US')
    }
  }

  componentWillUnmount() {
    const bodyElement = document.querySelector('body')
    bodyElement.classList.remove('enable-new-header-navigation')
  }

  getConsent = async (term1, term2) => {
    const { consents } = await customerContainer.signupConsents()
    const otherInfo = {
      browser: 'chrome',
      device: 'mobile',
      geoLocation:
        storeContainer.currentRegion || getLocalStorage('currentRegion') || '',
      ipAddress: consentIpAddress,
    }
    const signUpConsents = []
    consents.forEach(consent => {
      const Id = consent.id
      let consentInfo = ''
      if (
        term1 &&
        consent.title === 'I acknowledge I have read Sales performance'
      ) {
        consentInfo = {
          id: Id,
          consentId: Id,
          ...otherInfo,
          createdTimestamp: consent.createdTimestamp,
          updatedTimestamp: consent.updatedTimestamp,
        }
        signUpConsents.push(consentInfo)
      }
      if (
        term2 &&
        consent.title === 'I have Read, Understand, Agree to BA agreement'
      ) {
        consentInfo = {
          id: Id,
          consentId: Id,
          ...otherInfo,
          createdTimestamp: consent.createdTimestamp,
          updatedTimestamp: consent.updatedTimestamp,
        }
        signUpConsents.push(consentInfo)
      }
      if (consent.title === 'Terms & Conditions') {
        consentInfo = {
          id: Id,
          consentId: Id,
          ...otherInfo,
          createdTimestamp: consent.createdTimestamp,
          updatedTimestamp: consent.updatedTimestamp,
        }
        signUpConsents.push(consentInfo)
      }
    })
    const accType = getLocalStorage('accountType')
    const accountId = customerContainer.accountId
    const typeId = accountsContainer.profileResponse.typeId
    const name = accountsContainer.profileResponse.name
    const postData = {
      conversionType: 'TEMP_2_PERM',
      userConsent: [],
      account: {
        id: accountId,
        name: name,
        typeId: typeId,
        type: accType,
        addresses: [{}],
        customer: {},
      },
    }
    postData.userConsent = signUpConsents
    const loadParams = {
      endPointName: 'nextgenAccountUpgrade',
      pathParams: `${accountId}/upgrade`,
      postData,
    }
    const response = await customerContainer.fetchResponse(loadParams)
    if (customerContainer.isSuccessResponse(response)) {
    }
  }
  renderNewHomePage() {
    const isToEnableHPSSR = enableHomePageSSR()
    const wrapperClass = 'home-mfe-bg-color'
    const enableNarrowSymbolCurrencyFormat = enableNewFeature(
      'enableNarrowSymbolCurrencyFormat'
    )
    const enableDecimalRoundingInPrice = enableNewFeature(
      'enableDecimalRoundingInPrice'
    )
    const excludeSpaceInPrice = enableNewFeature('excludeSpaceInPrice')
    const remoteConfig = {
      appName: 'home-page',
      component: 'App',
    }
    const params = {
      customerData: customerContainer?.profileResponse,
      isEquinoxMysite: isEquinoxMysite(),
      mysitePriceType: mysiteContainer?.mysitePriceType,
      getTrackInsiderCartEvents: trackInsiderCartEvents,
      reqHeaderMysiteSponsorId: isEquinoxMysite()
        ? (mysiteContainer.mysiteSponsor ?? getSessionStorage(SPONSOR))
        : null,
      getProductStatusBadge: ProductStatusBadge,
      pageHistory: this.props.history,
      enableNarrowSymbolCurrencyFormat,
      enableDecimalRoundingInPrice,
      excludeSpaceInPrice,
    }
    return (
      <aside className={`POpage-wrapper  mb-0 ${wrapperClass}`}>
        <MicroFrontendLoader
          remoteConfig={remoteConfig}
          params={params}
          isToEnableSSR={isToEnableHPSSR}
        />
      </aside>
    )
  }
  renderNewPOSite() {
    return <PersonalOffer />
  }
  render() {
    const homePageTitle = i18nTranslate('homePage.title', 'Home | Nu Skin', {
      nameSpace: this.nameSpace,
    })
    /**
     * @note
     * NUSKIN-513 [CX121-246] | Console error is thrown on tapping the "Hi username" in header.
     * Commenting out the call, because of above mentioned mobx issue
     */
    // const triger = async () => {
    //   await accountsContainer.getProfile()
    // }
    // triger()
    let studioEntries = this.studioData?.entries?.[0]?.sections || []

    const seoInfo =
      enableNewFeature('enableHomePageSeo') &&
        studioContainer.nextgenHomepageData?.seo_information
        ? studioContainer.nextgenHomepageData.seo_information
        : this.studioData?.entries?.[0]?.seo_information

    const metaTitle = seoInfo?.meta_title || ''
    const metaDesc = seoInfo?.meta_description || ''
    const localeFromUrl = getLocaleCodeFromUrl()
    const enableLiveEvent = getLiveEventStatus()
    /* mysite admin can set whether they need homepage contetnt to show or hide*/
    if (isEquinoxMysite()) {
      const mysiteMarketData = mysiteContainer.mysiteShopHeaderResponse?.market
      const isToShowMysiteHomepage =
        mysiteMarketData?.showHomePageMarketingContent || false

      /* If mysite has api error or invalid subdomainand no valid shop header, showing error page*/
      if (mysiteContainer.mysiteApiError && !mysiteMarketData) {
        return <MysiteNotFound />
      }

      if (!isToShowMysiteHomepage) {
        return <></>
      }
    }
    if (enableLiveEvent == 'true') {
      return <EventStudioPage studioEntries={studioEntries} />
    }
    return (
      <>
        {customerContainer.isRegisterUser &&
          localStorage?.getItem('userActivationKey') && <EmailVerification />}
        <MetaDecorator
          title={metaTitle}
          imageUrl=""
          imageAlt=""
          description={metaDesc}
          location={this.props}>
          <link
            href={fontDetails[localeFromUrl]?.primaryFontUrl}
            rel="stylesheet"
          />
          <link
            href={fontDetails[localeFromUrl]?.secondaryFontUrl}
            rel="stylesheet"
          />
        </MetaDecorator>

        {isEquinoxPOSite() ? this.renderNewPOSite() : this.renderNewHomePage()}
        {<style>{getCustomStyleForLocale(localeFromUrl)}</style>}
        {customerContainer?.qualificationResponse?.isQualificationEligible ===
          true &&
          customerContainer?.qualificationStoreResponse === true && (
            <LeaderPreviewModal />
          )}
      </>
    )
  }
}
export { StudioPage }
export default StudioPage
